import React from 'react'


const isValidCondition = (condition) => {
  if (Array.isArray(condition)) {
    return condition.length > 0;
  }

  if (typeof condition === 'object' && condition !== null) {
    return Object.keys(condition).length > 0;
  }

  if (typeof condition === 'string') {
    return condition.trim().length > 0;
  }

  if (typeof condition === 'number') {
    return condition !== 0;
  }

  return Boolean(condition); // fallback for boolean, symbols, etc.
};

const ConditionalRenderer = ({condition, children, elseComponent}) => {
  return (
    <>
    {isValidCondition(condition) ? children : elseComponent ?? null}
    </>
  )
}

export default ConditionalRenderer